import { RoleSpoofingModal } from '@/src/components/spoofed-groups/RoleSpoofingModal';
import { config } from '@/src/config/app-config';
import { useCookieConsent } from '@/src/store/cookie-consent.context';
import { useUser } from '@/src/store/user.context';
import { isDev, isPreProd } from '@/src/utils/env.utils';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { privacy, siteTerms } from '@/src/utils/jam-urls';
import { Badge, Button, Link } from '@amzn/awsui-components-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DefaultFooter.module.scss';

export const DefaultFooter: React.FC = () => {
  const { t } = useTranslation();
  const { customizeCookies } = useCookieConsent();
  const { isLoggedIn } = useUser();
  const [showRoleSpoofingModal, setShowRoleSpoofingModal] = useState<boolean>(false);

  return (
    <div id={styles.container}>
      <div id={styles.footerContent}>
        <span className={styles.footerItem}>
          {isPreProd() && <Badge className="inline">{config.stageName.toUpperCase()}</Badge>}
        </span>
        <span className={styles.footerItem} data-testid="footer-privacy">
          <Link className="mr-8" href={privacy} target="_blank" rel="noopener noreferrer">
            {t(i18nKeys.footer.privacy)}
          </Link>
        </span>
        <span className={styles.footerItem} data-testid="footer-terms">
          <Link href={siteTerms} target="_blank" rel="noopener noreferrer">
            {t(i18nKeys.footer.siteTerms)}
          </Link>
        </span>
        <span className={styles.footerItem} data-testid="footer-cookies">
          <Link onFollow={customizeCookies}>{t(i18nKeys.footer.cookie)}</Link>
        </span>
        <span className={styles.footerItem} data-testid="footer-copyright">
          <span className={styles.copyright}>
            {t(i18nKeys.footer.copyright, { name: `©${new Date().getFullYear()} Amazon.com` })}
          </span>
        </span>
      </div>
      <div id={styles.footerEnd}>
        {isDev() && isLoggedIn && (
          <Button
            className={styles.roleSpoofing}
            iconName="settings"
            variant="inline-icon"
            onClick={() => setShowRoleSpoofingModal(true)}
            data-testid="footer-role-spoofing"
          />
        )}
        {showRoleSpoofingModal && <RoleSpoofingModal handleCloseModal={() => setShowRoleSpoofingModal(false)} />}
        <div id="shortbread-container" />
      </div>
    </div>
  );
};
